<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import { required } from "vuelidate/lib/validators";
import { cloneDeep, groupBy, orderBy } from "lodash";
import { Carousel, Slide } from "vue-carousel";
import Loader from "@/components/widgets/loader.vue";
import ApiResourceLogs from "@/components/modals/api-resource-logs.vue";
import PrintOptions from "@/components/modals/print-options.vue";
import createNumberMask from "text-mask-addons/dist/createNumberMask";
import MaskedInput from "vue-text-mask";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import map from "lodash/map";
import uniqueId from "lodash/uniqueId";
import Swal from "sweetalert2";
import RawData from "@/components/widgets/raw-data.vue";

export default {
    page: {
        title: "My Planning Budget Items",
    },
    components: {
        Layout,
        PageHeader,
        Carousel,
        Slide,
        Loader,
        ApiResourceLogs,
        PrintOptions,
        MaskedInput,
        Treeselect,
        RawData,
    },
    data() {
        return {
            title: "My Planning Budget Items",
            submitted: false,
            items: [
                {
                    text: "Dashboards",
                    href: "/",
                },
                {
                    text: "My Planning Budget Items",
                    active: true,
                },
            ],
            budgetData: [],
            modalTitle: "",
            currentPageBudget: 1,
            perPageBudget: 10,
            pageOptions: [10, 25, 50, 100],
            filterBudget: "",
            filterOn: [],
            form: {
                id: 0,
            },
            indexSelected: -1,
            tableBusy: false,
            selectedBudget: "",
            selectedBudgetAmount: 0,
            selectedBudgetId: 0,
            selectedPPMPStatus: "",
            // items
            itemList: [],
            filterItem: "",
            perPageItem: 10,
            currentPageItem: 1,
            resourceItems: [],
            bliExpired: false,
            itemLoading: false,
            item: {
                id: 0,
                itemName: "",
                description: "",
                unitId: "",
                type: "NON-CSE",
                itemCategoryId: "",
                unitCost: "0",
                cseId: 0,
                apiId: 0,
                deliveryUnitBudgetItemId: 0,
                isProcurable: false,
            },
            itemCategory: "",
            unit: "",
            // details
            itemDetails: [],
            itemDetailFields: [
                {
                    key: "month.monthName",
                    label: "Month",
                    variant: "primary",
                },
                {
                    key: "quantity",
                    label: "Qty",
                    variant: "primary",
                    thStyle: { width: "120px" },
                },
                {
                    label: "Total",
                    key: "total",
                    variant: "primary",
                    thStyle: { width: "200px" },
                },
            ],
            detail: {
                id: 0,
                monthId: 0,
                quantity: "0",
                totalAmt: 0,
            },
            moveToSaving: null,
            saving: {
                id: 0,
                amount: "0",
                deliveryUnitBudgetItemId: null,
            },
            currencyMask: createNumberMask({
                prefix: "",
                allowDecimal: true,
            }),
            slideNo: 0,
            savings: [],
            transferOEFunds: null,
            addOEFund: null,
            availableAccounts: [],
            accounts: null,
            departments: [],
            departmentAlloc: {
                id: 0,
                departmentId: 0,
                financeTemplateBudgetItemId: 0,
                amount: 0,
            },
            addDepartmentAlloc: false,
            allocatedItems: [],
            filteredDepartments: [],
            allocationLoading: false,
            selectedAccount: null,
            selectedBudgetForDep: null,
            depAllocCopy: null,
            selectedBudgetForTransfer: null,
            transferIR: false,
            moveToBudget: null,
            transferBudgetAllocation: false,
        };
    },
    validations: {
        saving: {
            amount: { required },
        },
        departmentAlloc: {
            amount: { required },
        },
    },
    computed: {
        filteredBudget() {
            let data = this.budgetData;
            if (this.filterBudget.trim() != "" && this.filterBudget) {
                data = data.filter((item) => {
                    return item.groupName
                        .toUpperCase()
                        .includes(this.filterBudget.toUpperCase());
                });
            }
            var groupedFS = groupBy(data, "fundSource");
            var grouped = [];
            var id = 1;
            var FCID = 1;
            for (const key in groupedFS) {
                var sumBalance = 0;
                var sumAllocated = 0;
                var sumDepartmentAlloc = 0;
                groupedFS[key].forEach((a) => {
                    sumBalance += a.balance;
                    sumAllocated += a.amount;
                    sumDepartmentAlloc += a.cascadedFunds;
                });
                var group = groupBy(groupedFS[key], "fundClass");
                var FC = [];
                for (const y in group) {
                    FC.push({
                        id: FCID++,
                        data: orderBy(group[y], ['accountGroup'], ['asc']),
                        key: y,
                        allowAdd: group[y][0].allowAdd,
                    });
                }
                grouped.push({
                    id: id++,
                    fsName: key,
                    data: orderBy(FC, ['key'], ['asc']),
                    balance: sumBalance,
                    allocated: sumAllocated,
                    departmentAlloc: sumDepartmentAlloc,
                    fsId: FC[0].data[0].fundSourceId,
                    financeTemplateId: FC[0].data[0].financeTemplateId,
                });
            }
            return orderBy(grouped, ['fsName'], ['asc']);
        },
        rowsBudget() {
            if (this.filterBudget.trim() != "" && this.filterBudget) {
                return this.filteredBudget.length;
            } else {
                return this.budgetData.length;
            }
        },
        filteredResourceItems() {
            let data = this.resourceItems;
            var total = this.currentPageItem * this.perPageItem;
            if (this.filterItem.trim() != "" && this.filterItem) {
                data = data.filter((item) => {
                    return item.filterKey
                        .toUpperCase()
                        .includes(this.filterItem.toUpperCase());
                });
            }
            var currentData = data.slice(total - this.perPageItem, total);
            if (this.currentPageItem > 1 && currentData.length == 0) {
                total = (this.currentPageItem - 1) * this.perPageItem;
                currentData = data.slice(total - this.perPageItem, total);
            }
            return currentData;
        },
        rowsResourceItem() {
            if (this.filterItem.trim() != "" && this.filterItem) {
                return this.filteredResourceItems.length;
            } else {
                return this.resourceItems.length;
            }
        },
        filteredSelectedResource() {
            let data = [];
            this.resourceItems.map(item => {
                item.planningApiResources.map(x => {
                    if (x.selected) {
                        data.push(x);
                    }
                });
            });
            return data;
        },
        totalTransferResources() {
            var data = this.filteredSelectedResource;
            var sum = data.reduce((pv, cv) => {
                return parseFloat(pv) + parseFloat(cv.total);
            }, 0);
            return sum;
        },
        totalBudget() {
            var totalBalance = this.selectedBudgetAmount;
            return (totalBalance -= parseFloat(this.detail.totalAmt));
        },
        quantityTotal() {
            var data = this.itemDetails;
            return data.reduce((pv, cv) => {
                return parseFloat(pv) + parseFloat(cv.quantity);
            }, 0);
        },
        amountTotal() {
            var data = this.itemDetails;
            var sum = data.reduce((pv, cv) => {
                return parseFloat(pv) + parseFloat(cv.totalAmt);
            }, 0);
            return this.formatCurrency(sum);
        },
        totalSavings() {
            var data = this.savings;
            var sum = data.reduce((pv, cv) => {
                return parseFloat(pv) + parseFloat(cv.totalSavings);
            }, 0);
            return this.formatCurrency(sum);
        },
    },
    created() {
        this.$store
            .dispatch("month/GetAllMonths")
            .then((res) => {
                this.months = res.data;
            })
            .catch((err) => {
                this.showToast("Something went wrong!", "error");
            });
        this.changeCycle(this.$store.state.data.cycle);
        this.getDepartments(this.$store.state.data.selectedDU.id);
    },

    methods: {
        changeCycle(cycle) {
            this.transferOEFunds = null;
            this.moveToSaving = null;
            this.getOfficeBudget(cycle, this.$store.state.data.selectedDU.id);
        },
        async getMySavings(cycle) {
            await this.$store
                .dispatch("savings/GetMySavings", cycle)
                .then((res) => {
                    res.data.map((item) => {
                        item.showDetails = false;
                        item.details = [];
                    });
                    this.savings = res.data;
                })
                .catch(() => {
                    this.showToast("Something went wrong!", "error");
                });
        },
        totalResourceItemAmt() {
            var data = this.resourceItems;
            var sum = 0;
            data.forEach((item) => {
                item.planningApiResources.map((x) => {
                    sum += parseFloat(x.total);
                });
            });
            return this.formatCurrency(sum);
        },
        getOfficeBudget(cycle, deliveryUnitId) {
            this.budgetData = [];
            this.tableBusy = true;
            this.$store
                .dispatch("financeTemplate/getDeliveryUnitFunds", { cycle, deliveryUnitId })
                .then((res) => {
                    if (res.data.error) {
                        return this.showToast(res.data.errorMessage, "error");
                    }
                    res.data.forEach((item) => {
                        item.fundClass = item.fundClassification.classification;
                        item.fundSource = item.sourceName;
                        item.accountGroup = item.groupName;
                    });
                    this.budgetData = res.data;
                    this.tableBusy = false;
                    this.slideNo = 0;
                    this.$refs.carousel.goToPage(0);
                })
                .catch((err) => {
                    this.tableBusy = false;
                    this.showToast("Something went wrong!", "error");
                });
        },
        viewItems(row) {
            if (this.transferOEFunds && this.transferOEFunds.id) return;
            if (this.transferIR) return;
            this.bliExpired = row.expired;
            this.selectedBudgetForTransfer = cloneDeep(row);
            this.selectedBudget = row.groupName;
            this.selectedBudgetId = row.id;
            this.selectedBudgetAmount = row.balance;
            this.selectedResourceStatus = row.status;
            this.budgetIndex = this.budgetData.indexOf(row);
            this.title = "Resource Items";
            this.slideNo = 1;
            this.$refs.carousel.goToPage(this.$refs.carousel.getNextPage());
            this.getResourceDetails(row.id);
            this.scrollToTop();
        },
        getResourceDetails(id) {
            this.resourceItems = [];
            this.itemLoading = true;
            this.$store
                .dispatch("planningapiresource/GetSimplePlanningApiResources", id)
                .then((res) => {
                    if (res.data.error) {
                        return this.showToast(res.data.errorMessage, "error");
                    }
                    res.data.map((item) => {
                        item.filterKey = item.api;
                        item.planningApiResources.map(x => {
                            x.selected = false;
                            item.filterKey += ` ${x.itemName}`;
                            x.filterKey = x.itemName;
                        })
                    });
                    this.resourceItems = res.data;
                    this.itemLoading = false;
                })
                .catch((err) => {
                    this.itemLoading = false;
                    this.showToast("Something went wrong!", "error");
                });
        },
        returnToBudget() {
            this.slideNo = 0;
            this.title = "Resources For:";
            this.$refs.carousel.goToPage(this.$refs.carousel.getPreviousPage());
        },
        hideModalDetail() {
            this.$bvModal.hide("create-item-modal");
        },
        viewItemLogs({ id }) {
            this.$refs.itemlog.getData(id);
            this.$bvModal.show("api-resoure-log-modal");
        },
        viewResourceItem(props) {
            this.item = cloneDeep(props);
            this.item.unitCost = props.unitCost.toString();
            this.unit = props.unit.shortName;
            this.itemCategory = props.itemCategory.name;
            this.itemIndex = this.resourceItems.indexOf(props);
            this.selectedBudgetAmount = cloneDeep(
                this.budgetData[this.budgetIndex].balance
            );
            this.modalTitle = "View Resource Item";
            this.$bvModal.show("create-item-modal");
            props.planningApiResourceDetails.forEach((item) => {
                if (this.item.type === 'CSE') {
                    let total = parseFloat(this.item.unitCost) * parseFloat(item.quantity);
                    let inflation = parseFloat(total) * (this.item.inflation / 100);
                    item.totalAmt = total + inflation;
                } else {
                    item.totalAmt = parseFloat(this.item.unitCost) * parseFloat(item.quantity);
                }
                item.total = this.formatCurrency(item.totalAmt);
                item.month = this.months.find(x => x.id == item.monthId);
            });
            this.itemDetails = props.planningApiResourceDetails;
        },
        printPPMP(id) {
            this.$refs.printOpt.putOptions({
                apiUrl: "api/Report/My/PPMP",
                routeVariables: [this.$store.state.data.cycle, id],
            });
            this.$bvModal.show("print-options-modal");
        },
        async printRAOS(id) {
            this.$refs.printOpt.putOptions({
                apiUrl: "api/Report/Finance/RAOS/DeliveryUnit",
                routeVariables: [id],
            });
            this.$bvModal.show("print-options-modal");
        },
        async printPPMPCampus() {
            this.$refs.printOpt.putOptions({
                apiUrl: "api/Report/Planning/Campus/PPMP",
                routeVariables: [this.$store.state.data.cycle],
            });
            this.$bvModal.show("print-options-modal");
        },
        async printPPMPDU() {
            this.$refs.printOpt.putOptions({
                apiUrl: "api/Report/Preplanning/PPMP",
                routeVariables: [this.$store.state.data.cycle, this.$store.state.data.selectedDU.id],
            });
            this.$bvModal.show("print-options-modal");
        },
        // async printDULIB() {
        //     this.$refs.printOpt.putOptions({
        //         apiUrl: "api/Report/Planning/LIB/DeliveryUnit",
        //         routeVariables: [this.$store.state.data.cycle],
        //     });
        //     this.$bvModal.show("print-options-modal");
        // },
        async printDraftPPMP() {
            this.$refs.printOpt.putOptions({
                apiUrl: "api/Report/My/Draft/PPMP",
                routeVariables: [this.$store.state.data.cycle],
            });
            this.$bvModal.show("print-options-modal");
        },
        addSaving(row) {
            this.moveToSaving = cloneDeep(row);
            this.saving.amount = row.balance.toString();
            this.modalTitle = "Move to Savings";
            this.$bvModal.show("saving-modal");
        },
        async submitSavings() {
            this.submitted = true;
            this.$v.saving.$touch();
            if (this.$v.saving.$invalid) {
                this.submitted = false;
                return;
            }
            if (
                this.getExactAmt(this.saving.amount) >
                this.transferOEFunds.balance
            ) {
                this.showToast(
                    "Amount should not be greater than the budget balance",
                    "error"
                );
                this.submitted = false;
                return;
            }
            // await this.$store
            //     .dispatch("savings/AddSavings", {
            //         deliveryUnitBudgetItemId: this.moveToSaving.id,
            //         amount: this.getExactAmt(this.saving.amount),
            //     })
            //     .then((res) => {
            //         if (res.data.error) {
            //             this.showToast(res.data.errorMessage, "error");
            //         }
            //         let data = {
            //             fundSource: this.moveToSaving.financeTemplateObjectOfExpenditure.fundSource,
            //             fundSourceId: this.moveToSaving.financeTemplateObjectOfExpenditure.fundSourceId,
            //             totalSavings: this.getExactAmt(this.saving.amount),
            //         }
            //         let index = this.budgetData.findIndex(
            //             (x) => x.id == this.moveToSaving.id
            //         );
            //         this.budgetData[index].balance -= parseFloat(this.getExactAmt(
            //             this.saving.amount)
            //         );
            //         let savingIndex = this.savings.findIndex(
            //             (x) =>
            //                 x.fundSourceId ==
            //                 this.moveToSaving.financeTemplateObjectOfExpenditure.fundSourceId
            //         );
            //         if(savingIndex == -1){
            //             this.savings.push(data);
            //         }else{
            //             this.savings[savingIndex].totalSavings += parseFloat(this.getExactAmt(
            //                 this.saving.amount)
            //             );
            //         }
            //         this.showToast("Successfully added", "success");
            //         this.$bvModal.hide("saving-modal");
            //     })
            //     .catch(() => {
            //         this.showToast("Something went wrong!", "error");
            //     });
            await this.$store
                .dispatch("preplanningtarget/TransferFund", {
                    fromId: this.transferOEFunds.id,
                    toId: this.moveToSaving.id,
                    amount: this.getExactAmt(this.saving.amount),
                })
                .then((res) => {
                    if (res.data.error) {
                        this.showToast(res.data.errorMessage, "error");
                    }
                    let fromIndex = this.budgetData.findIndex(
                        (x) => x.id == this.transferOEFunds.id
                    );
                    this.budgetData[fromIndex].balance -= parseFloat(
                        this.getExactAmt(this.saving.amount)
                    );
                    this.budgetData[fromIndex].amount -= parseFloat(
                        this.getExactAmt(this.saving.amount)
                    );
                    let toIndex = this.budgetData.findIndex(
                        (x) => x.id == this.moveToSaving.id
                    );
                    this.budgetData[toIndex].balance += parseFloat(
                        this.getExactAmt(this.saving.amount)
                    );
                    this.budgetData[toIndex].amount += parseFloat(
                        this.getExactAmt(this.saving.amount)
                    );
                    this.cancelTransfer();
                    this.showToast("Successfully transfered", "success");
                    this.$bvModal.hide("transfer-fund-modal");
                })
                .catch(() => {
                    this.showToast("Something went wrong!", "error");
                });
            this.submitted = false;
        },
        getSavingDetails(row) {
            row.showDetails = !row.showDetails;
            if (row.showDetails && row.details.length == 0) {
                this.$store
                    .dispatch("savings/GetSavingDetails", {
                        id: row.fundSourceId,
                        cycle: this.$store.state.data.cycle,
                    })
                    .then((res) => {
                        row.details = res.data;
                    });
            }
        },
        transferFunds(row) {
            this.transferOEFunds = cloneDeep(row);
        },
        transferHere(row) {
            this.moveToSaving = cloneDeep(row);
            this.modalTitle = "Transfer Funds";
            this.$bvModal.show("transfer-fund-modal");
        },
        transferResourceHere(row) {
            this.moveToBudget = cloneDeep(row);
            this.modalTitle = "Transfer Resources";
            this.transferBudgetAllocation = false;
            if (this.moveToBudget.balance < this.totalTransferResources && row.allowTransfer) {
                this.transferBudgetAllocation = true;
            }
            this.$bvModal.show("transfer-resource-modal");
        },
        cancelTransfer() {
            this.saving.amount = "0";
            this.transferOEFunds = null;
            this.moveToSaving = null;
        },
        async addMoreFund(row) {
            this.addOEFund = cloneDeep(row);
            this.pageLoader(true);
            await this.getAvailableAccounts(row.data[0].financeTemplateId);
            this.pageLoader(false);
            this.modalTitle = "Add More Account";
            this.$bvModal.show("add-funds");
        },
        async getAvailableAccounts(data) {
            let ids = [];
            this.addOEFund.data.map(item => {
                ids.push(item.accountGroupId);
            })
            await this.$store
                .dispatch("preplanningtarget/AvailableAccounts", data)
                .then((response) => {
                    let groups = [];
                    response.data.map((item) => {
                        let accountGroups = [];
                        item.accountGroups.map((group) => {
                            if (group.accountType.toUpperCase() === "EXPENSES" && group.fundClassificationId == this.addOEFund.data[0].fundClassification.id && !ids.includes(group.id)) {
                                accountGroups.push(group);
                            }
                        });
                        if (accountGroups.length > 0) {
                            groups.push({
                                id: item.id,
                                shortName: item.shortName,
                                classification: item.classification,
                                accountGroups: accountGroups,
                            });
                        }
                    });
                    this.availableAccounts = map(groups, (item) => ({
                        id: uniqueId("fc_"),
                        label: item.classification,
                        children: item.accountGroups.map((group) => ({
                            id: group.id,
                            label: `${group.groupName} - (${group.accountType})`,
                            // children: group.accounts.map((account) => ({
                            //     id: account.id,
                            //     label: account.accountName,
                            // })),
                        })),
                    }));
                })
                .catch((err) => {
                    this.showToast("Something went wrong!", "error");
                });
        },
        addOENow() {
            let accountIds = [];
            this.accounts.map(item => {
                accountIds.push({ id: item });
            })
            let data = {
                financeTemplateId: this.addOEFund.data[0].financeTemplateId,
                accountIds: accountIds,
                deliveryUnitId: this.$store.state.data.selectedDU.id,
            };
            this.$store
                .dispatch("preplanningtarget/AddFund", data)
                .then((response) => {
                    if (response.data.error) {
                        return this.showToast(response.data.errorMessage, "error");
                    }
                    this.accounts = null;
                    this.getOfficeBudget(this.$store.state.data.cycle, this.$store.state.data.selectedDU.id);
                    this.$bvModal.hide("add-funds");
                    this.showToast("Successfully added", "success");
                })
                .catch(() => {
                    this.showToast("Something went wrong!", "error");
                });
        },
        removeFund(row) {
            if (row.amount > 0) {
                this.showToast("Cannot remove fund with allocation", "error");
                return;
            }
            Swal.fire({
                title: "Are you sure?",
                text: "You won't be able to revert this!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#dc3545",
                cancelButtonColor: "#5c636a",
                confirmButtonText: "Yes, delete it!",
            }).then((result) => {
                if (result.value) {
                    this.$store
                        .dispatch("preplanningtarget/RemoveFund", row.financeTemplateObjectOfExpenditureId)
                        .then((response) => {
                            this.budgetData.splice(
                                this.budgetData.findIndex((x) => x.id == row.id),
                                1
                            );
                            this.showToast("Successfully removed", "success");
                        })
                        .catch(() => {
                            this.showToast("Something went wrong!", "error");
                        });
                }
            });
        },
        changeDU(du) {
            this.getOfficeBudget(this.$store.state.data.cycle, du.id);
            this.getDepartments(du.id);
        },
        async getDepartments(id) {
            await this.$store
                .dispatch("department/GetDepartmentByDU", id)
                .then((res) => {
                    if (res.data.error) {
                        return this.showToast(res.data.errorMessage, "error");
                    }
                    this.departments = res.data;
                })
                .catch((err) => {
                    this.showToast("Something went wrong!", "error");
                });
        },
        async printPPMPByApi() {
            this.$refs.printOpt.putOptions({
                apiUrl: "api/Report/PrePlanning/All/PPMP/API",
                routeVariables: [this.$store.state.data.selectedDU.id, this.$store.state.data.cycle],
            });
            this.$bvModal.show("print-options-modal");
        },
        async printWFP() {
            this.$refs.printOpt.putOptions({
                apiUrl: "api/Report/PrePlanning/WFP",
                routeVariables: [this.$store.state.data.cycle, this.$store.state.data.selectedDU.id],
            });
            this.$bvModal.show("print-options-modal");
        },
        async printOPCR() {
            this.$refs.printOpt.putOptions({
                apiUrl: "api/Report/PrePlanning/OPCR",
                routeVariables: [this.$store.state.data.cycle, this.$store.state.data.selectedDU.id],
            });
            this.$bvModal.show("print-options-modal");
        },
        async printDULIB() {
            this.$refs.printOpt.putOptions({
                apiUrl: "api/Report/PrePlanning/LIB",
                routeVariables: [this.$store.state.data.cycle, this.$store.state.data.selectedDU.id],
            });
            this.$bvModal.show("print-options-modal");
        },
        async getAllocatedItems(id) {
            await this.$store
                .dispatch("departmentplanningbudgetitem/GetAllBudgetItem", id)
                .then((res) => {
                    if (res.data.error) {
                        return this.showToast(res.data.errorMessage, "error");
                    }
                    this.allocatedItems = res.data;
                })
                .catch((err) => {
                    this.showToast("Something went wrong!", "error");
                });
        },
        async allocateToDepartment(row) {
            this.departmentAlloc = {
                id: 0,
                departmentId: 0,
                amount: "0",
                financeTemplateBudgetItemId: row.id,
            };
            this.selectedBudgetForDep = {
                financeTemplateBudgetItem: row,
                balance: cloneDeep(row.balance + row.cascadedFunds),
                allocated: cloneDeep(row.cascadedFunds),
            }
            this.addDepartmentAlloc = false;
            this.modalTitle = "Allocate to Department";
            this.$bvModal.show("allocate-modal");
            this.allocationLoading = true;
            this.selectedAccount = row;
            await this.getAllocatedItems(row.id);
            this.allocationLoading = false;
        },
        async saveDepartmentAllocation() {
            this.submitted = true;
            this.$v.departmentAlloc.$touch();
            if (this.$v.departmentAlloc.$invalid) {
                this.submitted = false;
                return;
            }
            let balance = parseFloat(this.selectedBudgetForDep.balance - this.selectedBudgetForDep.allocated).toFixed(2);
            if (parseFloat(this.getExactAmt(this.departmentAlloc.amount)) > parseFloat(balance)) {
                this.showToast(
                    "Amount should not be greater than the budget balance",
                    "error"
                );
                this.submitted = false;
                return;
            }
            let data = cloneDeep(this.departmentAlloc);
            data.amount = this.getExactAmt(this.departmentAlloc.amount);
            if (data.id > 0) {
                await this.$store
                    .dispatch("departmentplanningbudgetitem/UpdateDepartmentPlanningBudgetItem", data)
                    .then((res) => {
                        if (res.data.error) {
                            return this.showToast(res.data.errorMessage, "error");
                        }
                        let index = this.allocatedItems.findIndex((x) => x.id == data.id);
                        this.allocatedItems.splice(index, 1, res.data);
                        this.selectedBudgetForDep.allocated += parseFloat(this.getExactAmt(this.departmentAlloc.amount));
                        this.showToast("Successfully updated", "success");
                        this.addDepartmentAlloc = false;
                    })
                    .catch(() => {
                        this.showToast("Something went wrong!", "error");
                    });
            } else {
                await this.$store
                    .dispatch("departmentplanningbudgetitem/AddDepartmentPlanningBudgetItem", data)
                    .then((res) => {
                        if (res.data.error) {
                            return this.showToast(res.data.errorMessage, "error");
                        }
                        this.allocatedItems.push(res.data);
                        this.selectedBudgetForDep.allocated += parseFloat(this.getExactAmt(this.departmentAlloc.amount));
                        this.showToast("Successfully allocated", "success");
                        this.addDepartmentAlloc = false;
                    })
                    .catch(() => {
                        this.showToast("Something went wrong!", "error");
                    });
            }

            this.submitted = false;
        },
        removeAllocation(item) {
            Swal.fire({
                title: "Are you sure?",
                text: "You won't be able to revert this!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#dc3545",
                cancelButtonColor: "#5c636a",
                confirmButtonText: "Yes, delete it!",
            }).then((result) => {
                if (result.value) {
                    this.$store
                        .dispatch("departmentplanningbudgetitem/RemoveDepartmentPlanningBudgetItem", item.id)
                        .then((response) => {
                            if (response.data.error) {
                                return this.showToast('Someone used the allocation. Cannot be removed', "error");
                            }
                            this.selectedBudgetForDep.allocated -= parseFloat(item.amount);
                            this.allocatedItems.splice(this.allocatedItems.findIndex((x) => x.id == item.id), 1);
                            this.showToast("Successfully removed", "success");
                        })
                        .catch(() => {
                            this.showToast("Something went wrong!", "error");
                        });
                }
            });
        },
        recalculateBalance() {
            let sum = 0;
            this.allocatedItems.map(item => {
                sum += parseFloat(item.amount);
            })
            this.selectedAccount.cascadedFunds = sum;
            this.selectedAccount.balance = this.selectedAccount.amount - this.selectedAccount.totalUsed - sum;
        },
        updateAllocation(item) {
            let sum = 0;
            this.allocatedItems.map(item => {
                sum += parseFloat(item.amount);
            })
            console.log(sum);
            this.selectedBudgetForDep.allocated = sum;
            this.depAllocCopy = cloneDeep(item);
            this.addDepartmentAlloc = true;
            this.departmentAlloc = cloneDeep(item);
            this.departmentAlloc.amount = this.formatNumber(this.departmentAlloc.amount).toString();
            this.selectedBudgetForDep.allocated = this.selectedBudgetForDep.allocated - parseFloat(item.amount);

        },
        cancelAdding() {
            this.addDepartmentAlloc = false;
            if (this.depAllocCopy) {
                this.selectedBudgetForDep.allocated = this.selectedBudgetForDep.allocated + parseFloat(this.depAllocCopy.amount);
            }
        },
        addNewDepAlloc() {
            this.depAllocCopy = null;
            this.addDepartmentAlloc = true;
        },
        transferResourceItem() {
            this.transferIR = true;
            this.slideNo = 0;
            this.$refs.carousel.goToPage(0);
        },
        cancelTransferResource() {
            this.transferIR = false;
            this.slideNo = 1;
            this.$refs.carousel.goToPage(this.$refs.carousel.getNextPage());
        },
        submitTransferResource() {
            let ids = [];
            this.filteredSelectedResource.map(item => {
                ids.push({ id: item.id });
            });
            if (!this.transferBudgetAllocation && this.moveToBudget && this.moveToBudget.balance < this.totalTransferResources) {
                return this.showToast("Budget balance is not enough", "error");
            }
            Swal.fire({
                title: "Are you sure?",
                text: "You want to transfer this?",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#34c38f",
                cancelButtonColor: "#f46a6a",
                confirmButtonText: "Yes, transfer it!",
            }).then(async (result) => {
                if (result.value) {
                    this.$store
                        .dispatch("planningapiresource/TransferPlanningApiResource", {
                            id: this.moveToBudget.id,
                            ids: ids,
                            transferFund: this.transferBudgetAllocation
                        })
                        .then((response) => {
                            if (response.data.error) {
                                return this.showToast(response.data.errorMessage, "error");
                            }
                            this.showToast("Successfully transfered", "success");
                            this.$bvModal.hide("transfer-resource-modal");
                            this.transferIR = false;
                            this.moveToBudget = null;
                            this.getOfficeBudget(this.$store.state.data.cycle, this.$store.state.data.selectedDU.id);
                        })
                        .catch(() => {
                            this.showToast("Something went wrong!", "error");
                        });
                }
            });
        },
        getTotalResources(data) {
            return data.reduce((pv, cv) => {
                return parseFloat(pv) + parseFloat(cv.total);
            }, 0);
        },
        filterApiResources(arr) {
            let data = arr;
            if (this.filterItem.trim() != "" && this.filterItem) {
                data = data.filter((item) => {
                    return item.filterKey
                        .toUpperCase()
                        .includes(this.filterItem.toUpperCase());
                });
            }
            return data;
        },
        checkChildren(ev, api) {
            api.planningApiResources.map(item => {
                item.selected = ev.srcElement.checked;
            });
        },
        checkParent(id, api) {
            let checkbox = document.getElementById(id);
            checkbox.checked = api.planningApiResources.filter(item => item.selected).length == api.planningApiResources.length;
        }
    },
};
</script>

<template>
    <Layout @changeCycle="changeCycle" @changeDU="changeDU">
        <PageHeader :title="title" :items="items" />
        <b-modal id="add-funds" :title="modalTitle" size="md" title-class="font-18" hide-footer no-close-on-backdrop>
            <div>
                <h5>Fund Source: {{ addOEFund && addOEFund.fsName }}</h5>
            </div>
            <div class="row mb-3">
                <treeselect :multiple="true" :options="availableAccounts" value-consists-of="LEAF_PRIORITY" :limit="5"
                    :disable-branch-nodes="true" :max-height="300" v-model="accounts" :clearOnSelect="false" :class="{
                        'is-invalid':
                            accounts && accounts.length == 0 && submitted,
                    }" />
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-success" @click="addOENow">
                    Add Account
                </button>
                <button type="button" class="btn btn-link" @click="$bvModal.hide('add-funds')">
                    Close
                </button>
            </div>
        </b-modal>
        <b-modal id="transfer-fund-modal" :title="modalTitle" size="md" title-class="font-18" hide-footer
            no-close-on-backdrop>
            <form @submit.prevent="submitSavings">
                <div class="mb-2">
                    Balance:
                    {{
                        transferOEFunds &&
                        formatCurrency(transferOEFunds.balance)
                    }}
                </div>
                <div class="mb-2 text-info">
                    From:
                    {{
                        transferOEFunds &&
                        transferOEFunds.groupName
                    }}
                </div>
                <div class="mb-2 text-success">
                    To:
                    {{
                        moveToSaving &&
                        moveToSaving.groupName
                    }}
                </div>
                <div class="mb-2">
                    <label for="itemName" class="mb-0">Amount</label>
                    <masked-input autocomplete="off" type="text" placeholder="Enter Amount" class="form-control"
                        v-model="saving.amount" :mask="currencyMask"></masked-input>
                </div>
                <div class="modal-footer">
                    <button type="submit" class="btn btn-success">
                        Transfer Fund
                    </button>
                    <button type="button" class="btn btn-link" @click="$bvModal.hide('transfer-fund-modal')">
                        Close
                    </button>
                </div>
            </form>
        </b-modal>
        <b-modal id="create-item-modal" :title="modalTitle" size="lg" title-class="font-18" hide-footer
            no-close-on-backdrop>
            <div class="mb-2">
                <label for="itemName" class="mb-0">Item Name</label>
                <input autocomplete="off" type="text" placeholder="Input/Search Item..." class="form-control" disabled
                    v-model="item.itemName" />
            </div>
            <b-row class="mb-2">
                <b-col sm="9">
                    <label for="description" class="mb-0">Description </label>
                    <input autocomplete="off" id="name" type="text" v-model="item.description"
                        placeholder="Enter Description..." class="form-control" disabled />
                </b-col>
                <b-col sm="3">
                    <label for="name" class="mb-0">Type </label>
                    <b-form-select id="type" v-model="item.type" class="form-select custom-select" disabled>
                        <option></option>
                        <option>CSE</option>
                        <option>NON-CSE</option>
                    </b-form-select>
                </b-col>
            </b-row>
            <b-row class="mb-2">
                <b-col sm="5">
                    <label for="itemCategoryId" class="mb-0">Item Category
                    </label>
                    <input autocomplete="off" type="text" disabled placeholder="Search Item Category..."
                        class="form-control" v-model="itemCategory" />
                </b-col>
                <b-col sm="3">
                    <label for="unitId" class="mb-0">Unit </label>
                    <input autocomplete="off" type="text" disabled placeholder="Search Unit..." class="form-control"
                        v-model="unit" />
                </b-col>
                <b-col sm="4">
                    <label for="unitId" class="mb-0">Unit Cost</label>
                    <input autocomplete="off" id="unitId" type="text" :value="numberWithCommas(item.unitCost)"
                        class="form-control text-right" disabled />
                </b-col>
            </b-row>
            <b-row class="mb-3">
                <b-col sm="4">
                    <label for="isProcurable" class="mb-0">Procurable?</label>
                    <input autocomplete="off" id="isProcurable" type="text" :value="item.isProcurable ? 'Yes' : 'No'"
                        class="form-control" disabled />
                </b-col>
                <b-col sm="4">
                    <label for="isMixed" class="mb-0">Mixed?</label>
                    <input autocomplete="off" id="isMixed" type="text" :value="item.isMixed ? 'Yes' : 'No'"
                        class="form-control" disabled />
                </b-col>
            </b-row>
            <!-- <b-row class="mb-2">
                <b-col sm="4">
                    <input
                        autocomplete="off"
                        class="
                            form-check-input
                        "
                        type="checkbox"
                        id="isProcurable"
                        v-model="
                            item.isProcurable
                        "
                        disabled
                    />&nbsp;&nbsp;
                    <label
                        class="
                            form-check-label
                        "
                        for="isProcurable"
                        >Is
                        Procurable?</label
                    >
                    <div
                        v-if="
                            item.isProcurable
                        "
                    >
                        <select
                            class="
                                form-select
                            "
                            v-model="
                                item.subType
                            "
                            disabled
                        >
                            <option
                                value="Goods"
                            >
                                Goods
                            </option>
                            <option
                                value="Services"
                            >
                                Services
                            </option>
                            <option
                                value="Consultancy"
                            >
                                Consultancy
                            </option>
                            <option
                                value="Infrastructure"
                            >
                                Infrastructure
                            </option>
                        </select>
                    </div>
                </b-col>
            </b-row> -->
            <b-row class="mb-2">
                <b-col>
                    <b-table striped hover :items="itemDetails" :fields="itemDetailFields" show-empty>
                        <template #empty="scope">
                            <div class="text-center">
                                {{ scope.emptyText }}
                            </div>
                        </template>
                        <template #cell(quantity)="row">{{ numberWithCommas(row.value) }}</template>
                        <template #custom-foot>
                            <b-tr>
                                <b-th>Total</b-th>
                                <b-th>{{ numberWithCommas(quantityTotal) }}</b-th>
                                <b-th>
                                    <div>
                                        {{ amountTotal }}
                                    </div>
                                    <div>
                                        <small v-if="item.type === 'CSE'" class="text-warning">
                                            with inflation rate of {{ item.inflation }}%
                                        </small>
                                    </div>
                                </b-th>
                            </b-tr>
                        </template>
                    </b-table>
                </b-col>
            </b-row>
            <div class="modal-footer">
                <button type="button" class="btn btn-link" @click="hideModalDetail">
                    Close
                </button>
            </div>
        </b-modal>
        <b-modal id="allocate-modal" :title="modalTitle" size="lg" title-class="font-18" hide-footer
            no-close-on-backdrop no-close-on-esc @close="recalculateBalance">
            <div>
                <h5>Object of Expenditure: <span class="text-success">{{ selectedBudgetForDep &&
                    selectedBudgetForDep.financeTemplateBudgetItem &&
                    selectedBudgetForDep.financeTemplateBudgetItem.groupName }}</span></h5>
                <h5>Overall Balance: <span class="text-warning">{{ selectedBudgetForDep && selectedBudgetForDep.balance
                    ?
                    formatCurrency(selectedBudgetForDep.balance) : 0 }}</span></h5>
                <h5>Total Allocation: <span class="text-info">{{ selectedBudgetForDep && selectedBudgetForDep.allocated
                    ?
                    formatCurrency(selectedBudgetForDep.allocated) : 0 }}</span></h5>
                <h5>Available Balance: <span class="text-pink">{{ selectedBudgetForDep && selectedBudgetForDep.allocated
                    ?
                    formatCurrency(selectedBudgetForDep.balance - selectedBudgetForDep.allocated) :
                    `${selectedBudgetForDep
                        ? formatCurrency(selectedBudgetForDep.balance) : 0}` }}</span></h5>
            </div>
            <div>
                <table class="table table-striped table-bordered">
                    <thead>
                        <tr>
                            <th>Department</th>
                            <th>Amount</th>
                            <th style="width:90px;"></th>
                        </tr>
                    </thead>
                    <tbody>
                        <template v-if="allocationLoading">
                            <tr>
                                <td colspan="100%" class="text-center">
                                    <div class="d-flex justify-content-center align-items-center">
                                        <div class="preloader-component me-2">
                                            <div class="status">
                                                <div class="spinner-chase w-20px h-20px">
                                                    <div class="chase-dot" v-for="x in 5" :key="x"></div>
                                                </div>
                                            </div>
                                        </div>
                                        <strong>Loading...</strong>
                                    </div>
                                </td>
                            </tr>
                        </template>
                        <template v-else>
                            <tr v-for="(item, index) in allocatedItems" :key="index">
                                <td>{{ item.department.departmentName }}</td>
                                <td>{{ formatCurrency(item.amount) }}</td>
                                <td class="text-center">
                                    <!-- <i class="bx bx-edit cursor-pointer fs-5 me-1" @click="updateAllocation(item)"></i> -->
                                    <i class="bx bx-trash cursor-pointer fs-5 text-danger"
                                        @click="removeAllocation(item)"></i>
                                </td>
                            </tr>
                            <tr v-if="allocatedItems.length == 0">
                                <td colspan="100%" class="text-center">No data found</td>
                            </tr>
                        </template>
                    </tbody>
                </table>
            </div>
            <template v-if="addDepartmentAlloc">
                <form @submit.prevent="saveDepartmentAllocation">
                    <div class="row">
                        <div class="col-md-7">
                            <label for="department">Department</label>
                            <select class="form-select" v-model="departmentAlloc.departmentId"
                                :class="{ 'is-invalid': submitted && $v.departmentAlloc.departmentId == 0 }">
                                <option value="0">Select Department </option>
                                <option v-for="(item, index) in departments" :key="index" :value="item.id">{{
                                    item.departmentName }}</option>
                            </select>
                        </div>
                        <div class="col-md-5">
                            <label for="amount">Amount</label>
                            <div class="d-flex">
                                <masked-input autocomplete="off" type="text" placeholder="Enter Amount"
                                    class="form-control text-right me-1" v-model="departmentAlloc.amount"
                                    :mask="currencyMask"
                                    :class="{ 'is-invalid': submitted && $v.departmentAlloc.amount.$error }"></masked-input>
                                <div class="d-flex align-items-center">
                                    <i class="bx bx-check text-success fs-3 mx-1 cursor-pointer"
                                        @click="saveDepartmentAllocation"></i>
                                    <i class="bx bx-x text-danger fs-3 mx-1 cursor-pointer" @click="cancelAdding"></i>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </template>
            <template v-else>
                <button type="button" class="btn btn-info btn-block" @click="addNewDepAlloc"><i class="bx bx-plus"></i>
                    Add New Department Allocation</button>
            </template>
        </b-modal>
        <b-modal id="transfer-resource-modal" :title="modalTitle" size="md" title-class="font-18" hide-footer
            no-close-on-backdrop>
            <form @submit.prevent="submitTransferResource">
                <p>List of Resource to be Transfer: Total of <span class="text-warning">({{
                    formatCurrency(totalTransferResources) }})</span></p>
                <ul>
                    <li v-for="x in filteredSelectedResource" :key="x.id">{{ x.itemName }}</li>
                </ul>
                <p class="m-0">To be Transferred to:</p>
                <p class="m-0">
                    <span class="ms-2 fs-5 d-block"><i class="bx bx-star text-yellow me-1"></i>{{ moveToBudget &&
                        moveToBudget.sourceName }}</span>
                    <span class="ms-4 fs-6 d-block"><i class="bx bx-circle text-green me-1"></i>{{ moveToBudget &&
                        moveToBudget.groupName }}</span>
                </p>
                <p class="fs-5 mt-2">Balance: <span class="text-yellow">{{ formatCurrency(moveToBudget &&
                    moveToBudget.balance) }}</span></p>
                <div class="form-check form-checkbox-outline form-check-success mb-3"
                    v-if="moveToBudget && moveToBudget.allowTransfer">
                    <input class="form-check-input" type="checkbox" id="isPaidOnline"
                        v-model="transferBudgetAllocation" />
                    <label class="form-check-label" for="isPaidOnline">
                        Check if you want to also transfer the budget allocated
                    </label>
                </div>
                <div class="modal-footer">
                    <button type="submit" class="btn btn-success">
                        Transfer Resource
                    </button>
                    <button type="button" class="btn btn-link" @click="$bvModal.hide('transfer-resource-modal')">
                        Close
                    </button>
                </div>
            </form>
        </b-modal>
        <carousel ref="carousel" class="events navs-carousel" id="timeline-carousel" :navigation-enabled="false"
            :pagination-enabled="false" :perPage="1" :autoplay="false" :minSwipeDistance="0" :mouseDrag="false">
            <slide>
                <div v-if="slideNo == 0">
                    <div class="row">
                        <div class="col-md-6 d-flex">
                            <div id="tickets-table_filter" class="dataTables_filter me-1">
                                <label class="d-inline-flex align-items-center">
                                    <b-form-input autocomplete="off" v-model="filterBudget" type="search"
                                        placeholder="Search Budget..." class="form-control"></b-form-input>
                                </label>
                            </div>
                            <!-- <div
                                id="tickets-table_length"
                                class="dataTables_length"
                            >
                                <label
                                    class="
                                        d-inline-flex
                                        align-items-center
                                        mb-0
                                    "
                                >
                                    <b-form-select
                                        class="form-select"
                                        v-model="perPageBudget"
                                        size="sm"
                                        :options="pageOptions"
                                    ></b-form-select>
                                </label>
                            </div> -->
                        </div>
                        <div class="col-md-6 text-right">
                            <!-- <b-dropdown
                                id="dropdown-dropleft"
                                right
                                variant="purple"
                                toggle-class="text-decoration-none"
                                menu-class="dropdown-menu-end"
                                no-caret
                            >
                                <template #button-content>
                                    <i class="bx bx-printer me-1"></i> Reports
                                </template>
                                <b-dropdown-item
                                    @click="printWFP()"
                                    v-if="$store.state.data.selectedCampus.isExternal"
                                    >WFP</b-dropdown-item
                                >
                                <b-dropdown-item
                                    @click="printOPCR()"
                                    v-if="!$store.state.data.selectedCampus.isExternal"
                                    >OPCR</b-dropdown-item
                                >
                                <b-dropdown-item
                                    @click="printDULIB()"
                                    >LIB</b-dropdown-item
                                >
                                <b-dropdown-item
                                    @click="printPPMPByApi()"
                                    >PPMP</b-dropdown-item
                                >
                            </b-dropdown> -->
                        </div>
                        <div class="col-lg-12">
                            <div>
                                <div class="table-responsive">
                                    <table class="
                                            table
                                            project-list-table
                                            table-centered table-borderless
                                            align-middle
                                        ">
                                        <thead>
                                            <tr>
                                                <th scope="col" width="50px"></th>
                                                <th scope="col">Description</th>
                                                <th scope="col" width="250px">
                                                    Budget Allocated
                                                </th>
                                                <th scope="col" width="250px">
                                                    Total Resources
                                                </th>
                                                <th scope="col" width="250px">
                                                    Department Allocation
                                                </th>
                                                <th scope="col" width="250px">
                                                    Balance
                                                </th>
                                                <!-- <th scope="col" width="200px">
                                                    Expiry
                                                </th> -->
                                                <th scope="col" :width="`${transferOEFunds
                                                    ? '150px'
                                                    : '90px'
                                                    }`" class="text-center">
                                                    Action
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-if="tableBusy">
                                                <td colspan="100%">
                                                    <div class="d-flex justify-content-center align-items-center">
                                                        <div class="preloader-component me-2">
                                                            <div class="status">
                                                                <div class="spinner-chase w-20px h-20px">
                                                                    <div class="chase-dot"></div>
                                                                    <div class="chase-dot"></div>
                                                                    <div class="chase-dot"></div>
                                                                    <div class="chase-dot"></div>
                                                                    <div class="chase-dot"></div>
                                                                    <div class="chase-dot"></div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <strong>Loading...</strong>
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr v-if="budgetData.length == 0 && !tableBusy">
                                                <td colspan="100%" class="text-muted text-center">
                                                    <i class="dripicons-warning me-1"></i>No data found
                                                </td>
                                            </tr>
                                            <template v-for="y in filteredBudget">
                                                <tr :key="'A' + y.id" style="
                                                        background-color: transparent;
                                                        box-shadow: none;
                                                    ">
                                                    <td colspan="2" class="py-0">
                                                        <div class="
                                                                d-flex
                                                                align-items-center
                                                            ">
                                                            <span class="
                                                                    bx bx-star
                                                                    text-warning
                                                                    me-1
                                                                " style="
                                                                    line-height: unset;
                                                                "></span>
                                                            <h5 class="
                                                                    text-dark
                                                                    mb-0
                                                                    me-2
                                                                ">
                                                                {{ y.fsName }}
                                                            </h5>
                                                            <!-- <button
                                                                type="button"
                                                                class="
                                                                    btn
                                                                    btn-outline-info
                                                                    btn-sm
                                                                    me-2
                                                                "
                                                                @click="
                                                                    addMoreFund(
                                                                        y
                                                                    )
                                                                "
                                                            >
                                                                <i
                                                                    class="
                                                                        bx
                                                                        bx-plus
                                                                    "
                                                                ></i>
                                                                Add Object of
                                                                Expenditure
                                                            </button> -->
                                                            <!-- <button
                                                                type="button"
                                                                class="
                                                                    btn
                                                                    btn-outline-purple
                                                                    btn-sm
                                                                    me-2
                                                                "
                                                                @click="
                                                                    printPPMP(
                                                                        y.fsId
                                                                    )
                                                                "
                                                            >
                                                                <i
                                                                    class="
                                                                        bx
                                                                        bx-printer
                                                                    "
                                                                ></i>
                                                                Print PPMP
                                                            </button> -->
                                                        </div>
                                                    </td>
                                                    <td class="text-warning font-size-14">
                                                        {{ formatCurrency(y.allocated) }}
                                                    </td>
                                                    <td class="text-warning font-size-14">
                                                        {{ formatCurrency(y.allocated - y.balance) }}
                                                    </td>
                                                    <td class="font-size-14">
                                                        {{ formatCurrency(y.departmentAlloc) }}
                                                    </td>
                                                    <td class="text-warning font-size-14">
                                                        {{ formatCurrency(y.balance) }}
                                                    </td>
                                                    <td></td>
                                                </tr>
                                                <template v-for="z in y.data">
                                                    <tr :key="'B' + z.id"
                                                        style="background-color: transparent;box-shadow: none;">
                                                        <td colspan="100%" class="p-0-20p">
                                                            <div class="d-flex align-items-center">
                                                                <span class="bx bx-checkbox-square text-success me-1"
                                                                    style="line-height: unset;"></span>
                                                                <b class="text-dark">{{ z.key }}</b>
                                                                <button type="button"
                                                                    class="btn btn-outline-success btn-xs ms-1"
                                                                    v-if="z.allowAdd" @click="addMoreFund(z)"><i
                                                                        class="bx bx-plus"></i> Add Account</button>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                    <template v-for="x in z.data">
                                                        <tr :key="x.id"
                                                            style="background-color: transparent; box-shadow: none;">
                                                            <td>
                                                            </td>
                                                            <td class="
                                                                    bg-table-tr
                                                                    position-relative
                                                                ">
                                                                <RawData :data="x"
                                                                    v-if="$store.state.decrypt.isAdmin()" />
                                                                <h5 class="
                                                                        text-truncate
                                                                        font-size-14
                                                                        mb-0
                                                                        d-flex
                                                                    ">
                                                                    <a href="javascript: void(0);" class="text-dark"
                                                                        @click="viewItems(x)">
                                                                        {{ x.groupName }}
                                                                    </a>
                                                                    <div v-if="x.notification > 0">
                                                                        <span class="
                                                                                badge
                                                                                rounded-pill
                                                                                bg-danger
                                                                                float-end
                                                                            " style="font-size: 8px;">
                                                                            {{ x.notification > 0 ? x.notification : ""
                                                                            }}
                                                                        </span>
                                                                    </div>
                                                                </h5>
                                                                <small v-if="x.manuallyAddedByDeliveryUnit" class="
                                                                        text-warning
                                                                    ">
                                                                    Manually added by Delivery Unit
                                                                </small>
                                                            </td>
                                                            <td class="bg-table-tr">
                                                                {{ formatCurrency(x.amount) }}
                                                            </td>
                                                            <td class="bg-table-tr">
                                                                {{ formatCurrency(x.totalUsed + x.cascadedUsedImported)
                                                                }}
                                                                <div v-if="x.cascadedUsedImported > 0">
                                                                    <small class="d-block">DU: <span>{{
                                                                        formatCurrency(x.totalUsed)
                                                                            }}</span></small>
                                                                    <small class="d-block">Department: <span>{{
                                                                        formatCurrency(x.cascadedUsedImported)
                                                                            }}</span></small>
                                                                </div>
                                                            </td>
                                                            <td class="bg-table-tr">
                                                                <b>{{ formatCurrency(x.cascadedFunds) }}</b>
                                                                <div v-if="x.cascadedUsed != 0">
                                                                    <small class="d-block">Used: <span
                                                                            class="text-yellow">{{
                                                                                formatCurrency(x.cascadedUsed)
                                                                            }}</span></small>
                                                                    <small class="d-block">Balance: <span
                                                                            class="text-green">{{
                                                                                formatCurrency(x.cascadedFunds -
                                                                                    x.cascadedUsed) }}</span></small>
                                                                    <small class="d-block">Imported: <span
                                                                            class="text-info">{{
                                                                                formatCurrency(x.cascadedUsedImported)
                                                                            }}</span></small>
                                                                </div>
                                                            </td>
                                                            <td class="bg-table-tr">
                                                                <div>{{ formatCurrency(x.balance) }}</div>
                                                            </td>
                                                            <td class="text-center bg-table-tr">
                                                                <b-dropdown v-if="!transferOEFunds && !transferIR"
                                                                    id="dropdown-dropleft" right variant="link"
                                                                    toggle-class="text-decoration-none"
                                                                    menu-class="dropdown-menu-end" no-caret>
                                                                    <template #button-content>
                                                                        <i class="fas fa-ellipsis-v"></i>
                                                                    </template>
                                                                    <b-dropdown-item @click="
                                                                        viewItems(
                                                                            x
                                                                        )
                                                                        " variant="dark"><i class="
                                                                                mdi
                                                                                mdi-view-list
                                                                                font-size-18
                                                                                me-1
                                                                            "></i>View
                                                                        Items</b-dropdown-item>
                                                                    <b-dropdown-item @click="allocateToDepartment(x)"
                                                                        variant="info">
                                                                        <i
                                                                            class="mdi mdi-transfer font-size-18 me-1"></i>
                                                                        Allocate to Department
                                                                    </b-dropdown-item>
                                                                    <b-dropdown-item @click="
                                                                        transferFunds(
                                                                            x
                                                                        )
                                                                        " v-if="x.allowTransfer" variant="success"><i
                                                                            class="
                                                                                mdi
                                                                                mdi-transfer
                                                                                font-size-18
                                                                                me-1
                                                                            "></i>Transfer Funds</b-dropdown-item>
                                                                    <!-- <b-dropdown-item
                                                                        @click="
                                                                            removeFund(
                                                                                x
                                                                            )
                                                                        "
                                                                        variant="danger"
                                                                        v-if="x.allowTransfer"
                                                                        ><i
                                                                            class="
                                                                                mdi
                                                                                mdi-trash-can
                                                                                font-size-18
                                                                                me-1
                                                                            "
                                                                        ></i
                                                                        >Delete Fund</b-dropdown-item
                                                                    > -->
                                                                </b-dropdown>
                                                                <a v-if="
                                                                    transferOEFunds &&
                                                                    transferOEFunds.id &&
                                                                    transferOEFunds.id != x.id &&
                                                                    transferOEFunds.fundSourceId == x.fundSourceId
                                                                " href="javascript:void(0);" @click="transferHere(x)">
                                                                    <div class="
                                                                            text-success
                                                                            d-flex
                                                                            align-items-center
                                                                        ">
                                                                        Transfer
                                                                        here
                                                                        <i class="
                                                                                fas
                                                                                fa-hand-point-left
                                                                                pointing-animation
                                                                            "></i>
                                                                    </div>
                                                                </a>
                                                                <a v-if="
                                                                    transferIR &&
                                                                    selectedBudgetForTransfer &&
                                                                    selectedBudgetForTransfer.id &&
                                                                    selectedBudgetForTransfer.id != x.id &&
                                                                    selectedBudgetForTransfer.fundSourceId == x.fundSourceId &&
                                                                    (selectedBudgetForTransfer.fundClassification.id == x.fundClassification.id || $store.state.decrypt.isAdmin())
                                                                " href="javascript:void(0);"
                                                                    @click="transferResourceHere(x)">
                                                                    <div class="
                                                                            text-success
                                                                            d-flex
                                                                            align-items-center
                                                                            no-wrap px-3
                                                                        ">
                                                                        Transfer
                                                                        here
                                                                        <i class="
                                                                                fas
                                                                                fa-hand-point-left
                                                                                pointing-animation
                                                                            "></i>
                                                                    </div>
                                                                </a>
                                                            </td>
                                                        </tr>
                                                    </template>
                                                </template>
                                            </template>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- <div class="row mb-3">
                        <div class="col">
                            <div
                                class="
                                    dataTables_paginate
                                    paging_simple_numbers
                                    float-end
                                "
                            >
                                <ul class="pagination pagination-rounded mb-0">
                                    <b-pagination
                                        v-model="currentPageBudget"
                                        :total-rows="rowsBudget"
                                        :per-page="perPageBudget"
                                    ></b-pagination>
                                </ul>
                            </div>
                        </div>
                    </div> -->
                </div>
            </slide>
            <slide>
                <div v-if="slideNo == 1">
                    <div class="row">
                        <b-col sm="6">
                            <div class="d-flex align-items-center">
                                <a href="javascript:void(0);" class="me-1" @click="returnToBudget()"><i
                                        class="bx bx-left-arrow-alt fs-2"></i></a>
                                <div>
                                    <h4 class="m-0">
                                        {{ selectedBudget }}'s Items
                                    </h4>
                                </div>
                            </div>
                        </b-col>
                        <b-col sm="6" class="text-right">
                            <h4 class="text-muted mb-0">
                                Balance:
                                <b>{{ formatCurrency(totalBudget) }}</b>
                            </h4>
                            <h4 class="text-warning">
                                Total: <b>{{ totalResourceItemAmt() }}</b>
                            </h4>
                        </b-col>
                    </div>
                    <b-row>
                        <b-col sm="12" class="mt-2">
                            <div class="row">
                                <div class="col-md-6 d-flex">
                                    <div id="tickets-table_filter" class="dataTables_filter me-1">
                                        <label class="
                                                d-inline-flex
                                                align-items-center
                                            ">
                                            <b-form-input autocomplete="off" v-model="filterItem" type="search"
                                                placeholder="Search Items..." class="form-control"></b-form-input>
                                        </label>
                                    </div>
                                    <div id="tickets-table_length" class="dataTables_length">
                                        <label class="
                                                d-inline-flex
                                                align-items-center
                                                mb-0
                                            ">
                                            <b-form-select class="form-select" v-model="perPageItem" size="sm"
                                                :options="pageOptions"></b-form-select>
                                        </label>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="text-right" v-if="filteredSelectedResource.length != 0">
                                        <button type="button" class="btn btn-outline-info"
                                            @click="transferResourceItem">Transfer Selected
                                            ({{ filteredSelectedResource.length }}) to another LIB</button>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-lg-12">
                                    <div>
                                        <div class="table-responsive">
                                            <table class="
                                                    table
                                                    project-list-table
                                                    table-centered
                                                    table-borderless
                                                    align-middle
                                                ">
                                                <thead>
                                                    <tr>
                                                        <th scope="col" width="30px">
                                                        </th>
                                                        <th scope="col" style="min-width:280px;">
                                                            Item Name
                                                        </th>
                                                        <th scope="col">
                                                            Description
                                                        </th>
                                                        <th scope="col" width="120px">
                                                            Qty
                                                        </th>
                                                        <th scope="col" width="200px">
                                                            Unit Cost
                                                        </th>
                                                        <th scope="col" width="200px">
                                                            Total
                                                        </th>
                                                        <th scope="col" width="90px" class="text-center">
                                                            Action
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-if="itemLoading">
                                                        <td colspan="7">
                                                            <div
                                                                class="d-flex justify-content-center align-items-center">
                                                                <div class="preloader-component me-2">
                                                                    <div class="status">
                                                                        <div class="spinner-chase w-20px h-20px">
                                                                            <div class="chase-dot"></div>
                                                                            <div class="chase-dot"></div>
                                                                            <div class="chase-dot"></div>
                                                                            <div class="chase-dot"></div>
                                                                            <div class="chase-dot"></div>
                                                                            <div class="chase-dot"></div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <strong>Loading...</strong>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                    <tr v-if="filteredResourceItems.length == 0 && !itemLoading">
                                                        <td colspan="7" class="text-muted text-center">
                                                            <i class="dripicons-warning me-1"></i>No data found
                                                        </td>
                                                    </tr>
                                                    <template v-for="y in filteredResourceItems">
                                                        <tr :key="`firstRow-${y.id}`"
                                                            style="background-color: transparent; box-shadow: none;">
                                                            <td colspan="5" class="p-0 position-relative">
                                                                <div v-if="!y.isOpcrPosted">
                                                                    <div
                                                                        class="form-check form-checkbox-outline form-check-success">
                                                                        <input class="form-check-input" type="checkbox"
                                                                            :id="`api-${y.id}`"
                                                                            @change="checkChildren($event, y)" />
                                                                        <label class="form-check-label"
                                                                            :for="`api-${y.id}`">
                                                                            <b>{{ y.api }} <span v-if="y.department"
                                                                                    class="badge bg-purple">{{
                                                                                        y.department }}</span></b>
                                                                        </label>
                                                                    </div>
                                                                </div>
                                                                <div v-else><b>{{ y.api }} <span v-if="y.department"
                                                                            class="badge bg-purple">{{ y.department
                                                                            }}</span></b>
                                                                </div>
                                                                <RawData :data="y" v-if="$store.state.decrypt.isAdmin()"
                                                                    placement="left" />
                                                            </td>
                                                            <td>{{
                                                                formatCurrency(getTotalResources(y.planningApiResources))
                                                                }}
                                                            </td>
                                                            <td></td>
                                                        </tr>
                                                        <template
                                                            v-for="x in filterApiResources(y.planningApiResources)">
                                                            <tr :key="`secondRow-${y.id}-${x.id}`"
                                                                style="background-color:transparent;box-shadow:none;">
                                                                <td></td>
                                                                <td class="bg-table-tr position-relative">
                                                                    <RawData :data="x"
                                                                        v-if="$store.state.decrypt.isAdmin()" />
                                                                    <div v-if="!y.isOpcrPosted">
                                                                        <div
                                                                            class="form-check form-checkbox-outline form-check-success">
                                                                            <input class="form-check-input"
                                                                                type="checkbox"
                                                                                :id="`item-resource-${x.id}`"
                                                                                v-model="x.selected"
                                                                                @change="checkParent(`api-${y.id}`, y)" />
                                                                            <label class="form-check-label"
                                                                                :for="`item-resource-${x.id}`">
                                                                                {{ x.itemName }}
                                                                            </label>
                                                                        </div>
                                                                    </div>
                                                                    <div v-else>{{ x.itemName }}</div>
                                                                </td>
                                                                <td class="bg-table-tr">
                                                                    {{ x.description }}
                                                                </td>
                                                                <td class="bg-table-tr">
                                                                    {{ numberWithCommas(x.quantity) }}
                                                                </td>
                                                                <td class="bg-table-tr">
                                                                    {{ formatCurrency(x.unitCost) }}
                                                                </td>
                                                                <td class="bg-table-tr">
                                                                    {{ formatCurrency(x.total) }}
                                                                    <div v-if="x.totalInflation > 0">
                                                                        <small>Inflation:
                                                                            {{ formatCurrency(x.totalInflation)
                                                                            }}</small>
                                                                    </div>
                                                                </td>
                                                                <td class="text-center bg-table-tr">
                                                                    <b-dropdown class="card-drop"
                                                                        menu-class="dropdown-menu-end" variant="white"
                                                                        toggle-class="p-0">
                                                                        <template v-slot:button-content>
                                                                            <i
                                                                                class="mdi mdi-dots-horizontal font-size-18"></i>
                                                                        </template>
                                                                        <b-dropdown-item @click="viewItemLogs(x)"
                                                                            variant="dark">
                                                                            <i
                                                                                class="bx bx-menu-alt-right font-size-18 me-1"></i>View
                                                                            Logs
                                                                        </b-dropdown-item>
                                                                        <b-dropdown-item @click="viewResourceItem(x)"
                                                                            variant="dark">
                                                                            <i
                                                                                class="bx bx-edit font-size-18 me-1"></i>View
                                                                            Details
                                                                        </b-dropdown-item>
                                                                    </b-dropdown>
                                                                </td>
                                                            </tr>
                                                        </template>
                                                    </template>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row mb-3">
                                <div class="col mb-3">
                                    <div class="
                                            dataTables_paginate
                                            paging_simple_numbers
                                            float-end
                                        ">
                                        <ul class="
                                                pagination pagination-rounded
                                                mb-0
                                            ">
                                            <!-- pagination -->
                                            <b-pagination v-model="currentPageItem" :total-rows="rowsResourceItem"
                                                :per-page="perPageItem"></b-pagination>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </b-col>
                    </b-row>
                </div>
            </slide>
        </carousel>
        <loader :loading="submitted"></loader>
        <api-resource-logs ref="itemlog"></api-resource-logs>
        <print-options ref="printOpt"></print-options>
        <div v-if="transferOEFunds && transferOEFunds.id">
            <button type="button" class="btn btn-warning position-fixed" style="bottom: 5%; right: 3%"
                @click="cancelTransfer">
                <i class="bx bx-x me-1"></i>Cancel Transfer Fund
            </button>
        </div>
        <div v-if="transferIR">
            <button type="button" class="btn btn-warning position-fixed" style="bottom: 5%; right: 3%"
                @click="cancelTransferResource">
                <i class="bx bx-x me-1"></i>Cancel Transfer Resources
            </button>
        </div>
    </Layout>
</template>